import React from 'react';
import BaseMenuItem from '@mui/material/MenuItem';
import noop from 'lodash/noop';

import Typography from '../../Typography';
import { mergeOverrides } from '../../utils';
import { LegacyMenuItemProps } from './types';
import { COLOR_CLASSES, getDefaults } from './utils';

const LegacyMenuItem: React.FC<React.PropsWithChildren<LegacyMenuItemProps>> = (props) => {
  const {
    appearance = 'primary',
    as: Component = BaseMenuItem,
    disabled = false,
    icon,
    id,
    label,
    onClick,
    overrides,
  } = props;
  const classes = COLOR_CLASSES[appearance];
  const DEFAULTS = getDefaults(classes, disabled);

  const mergedOverrides = mergeOverrides(DEFAULTS, overrides);

  return (
    <Component
      {...mergedOverrides.BaseMenuItem}
      data-action={id}
      onClick={disabled ? noop : onClick}>
      <Typography variant="body-long-01" {...mergedOverrides.Typography}>
        {label}
      </Typography>
      <span className="menuItem-icon" {...mergedOverrides.EndIcon}>
        {icon}
      </span>
    </Component>
  );
};

export { LegacyMenuItemProps };
export default React.memo(LegacyMenuItem);
